  <div id="topbar" class="w-100 d-flex align-items-center ">
  <div class="container-fluid d-flex align-items-center justify-content-center justify-content-md-between">
    <div class="container w-auto">
      <a routerLink="/">
      <img ngSrc="assets/img/medilinkLogo.svg" alt="MediLink Logo" width="175" height="100">
      </a>
    </div>
    <div class="modeWeb d-flex align-items-center justify-content-end">

      <a class="" routerLink="/persona"  [ngClass]="{ 'active': isPersonaOrRoute}"   (click)="setActiveLink('personas')"><i class="bi bi-person"></i> Personas</a>
      <a routerLink="/empresa" [ngClass]="{'active': isEmpresaRoute }" (click)="setActiveLink('other')"><i class="bi bi-buildings"></i> Empresas</a>
    </div>
    <div class="container" id="horarioNav">
      <app-horario-nav-bar/>
    </div>
    <!--<div class="cta d-none d-md-block inputSearch">
      <div class="d-flex align-items-center justify-content-center justify-content-md-between">
        <input type="search" class="form-control" placeholder="¿Buscas algo?">
      </div>
    </div>-->
  </div>
</div>

<div class="b-example-divider"></div>
